class GalleryKlaviyoForm extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleSubmit = this.handleSubmit.bind(this)

    this.listeners.add(this.els.form.element, 'submit', this.handleSubmit)
  }

  async handleSubmit (event) {
    event.preventDefault()

    const customerEmail = this.els.email?.element?.value
    if (!customerEmail) return

    let listId = window.theme.klaviyo.newsletterListId

    // Country-specific list ID overrides.
    const customerCountry = this.dataset?.country || null
    if (customerCountry) {
      switch (customerCountry) {
        case 'Germany':
          listId = 'SF5ivA'
          break
        case 'South Korea':
          listId = 'TvmRXw'
          break
      }
    }

    try {
      const bodyData = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: customerEmail,
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED',
                      },
                    },
                  },
                },
              },
            },
            custom_source: this.customSource,
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId,
              },
            },
          },
        },
      }

      if (this.tagKey && this.tagValue) {
        bodyData.data.attributes.profile.data.attributes.properties = {
          [this.tagKey]: this.tagValue,
        }
      }

      const options = {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          revision: window.theme.klaviyo.apiVersion,
          'content-type': 'application/vnd.api+json',
        },
        body: JSON.stringify(bodyData),
      }

      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${window.theme.klaviyo.apiKey}`,
        options,
      )

      if (response.ok) {
        // Update UI state for gallery accordion
        this.externalEls['submitted-title'].element?.setAttribute(
          'aria-hidden',
          false,
        )
        this.externalEls['default-title'].element?.setAttribute(
          'aria-hidden',
          true,
        )
        this.externalEls['accordion-trigger'].element?.click()

        setTimeout(() => {
          this.externalEls.container.element?.remove()
        }, 5000)

        window.BAO.dispatchEvent(window.BAO.EVENTS.KLAVIYO.FORM_SUBMITTED, {
          customerEmail,
        })

        // Set cart attribute if configured
        if (this.tagKey && this.tagValue) {
          this.setCartAttribute(this.tagKey, this.tagValue)
        }
      } else {
        throw new Error(`API returned ${response.status}`)
      }
    } catch (error) {
      console.error('Klaviyo subscription error:', error)
      // TODO: Show error message to user if error element exists
      // if (this.els.error?.exists) {
      //   this.els.error.element.setAttribute('aria-hidden', false)
      // }
    }
  }

  setCartAttribute (attributeKey, attributeValue) {
    // eslint-disable-next-line compat/compat
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [attributeKey]: attributeValue,
        },
      }),
    })
  }

  get listId () {
    return this.dataset.listId || window.theme.klaviyo.newsletterListId
  }

  get customSource () {
    return this.dataset.customSource || null
  }

  get tagKey () {
    return this.dataset.tagKey
  }

  get tagValue () {
    return this.dataset.tagValue
  }
}

if (!customElements.get('gallery-klaviyo-form')) {
  customElements.define('gallery-klaviyo-form', GalleryKlaviyoForm)
}
